import {
  LANGUAGES,
  type TranslationLanguage,
  useTranslateHandler,
} from '@components/ArtBoard/ProjectToolbar'
import { Sparkles } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { ActionButton, ActionsMessage, UserMessage } from '../../../index'

export const TranslateActionsMessage: React.FC = () => {
  const translate = useTranslateHandler()

  const onClick = (value: TranslationLanguage) => {
    translate(value)
  }

  return (
    <>
      <UserMessage>Translate to...</UserMessage>

      <ActionsMessage>
        {LANGUAGES.map((lang) => (
          <ActionButton
            key={lang}
            icon={<Sparkles />}
            variant="purple"
            onClick={() => onClick(lang)}
          >
            {lang}
          </ActionButton>
        ))}
      </ActionsMessage>
    </>
  )
}
